
import React, { useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import blogsData from "./BlogData";

const Contact = () => {
  const [statusMsg, setStatusMsg] = useState("");
    const [isSuccess, setIsSuccess] = useState(null); 
    const [loading, setLoading] = useState(false);
     useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, []);

       const handleSubmit = async (e) => {
    e.preventDefault(); 
    setLoading(true);

    const formData = new FormData(e.target);

    try {

  const response = await fetch("https://bojotech.com/sendMail.php", {
    method: "POST",
    body: formData,
  });

  const resultText = (await response.text()).trim();
  console.log("API Response:", resultText);

  if (response.status === 200 && resultText.toLowerCase().includes("success")) {
    setIsSuccess(true);
    setStatusMsg("Your message has been sent. Thank you!");
    e.target.reset();
  } else {
    setIsSuccess(false);
    setStatusMsg("Failed to send message. Please try again.");
  }

} catch (err) {
  console.log(err);
  setIsSuccess(false);
  setStatusMsg("Failed to send message (Network error).");
} finally {
  setLoading(false);
}


    setTimeout(() => {
      setStatusMsg("");
      setIsSuccess(null);
    }, 5000);
     };
  return (
   <div >
  
     {/* Breadcrumb */}
    
<section
  className="section mt-5 contact-hero"
  style={{
    backgroundImage: `url('/assets/img/about-bg.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    padding: '60px 0',
    position: 'relative',
    color: '#fff',
    textAlign: 'center',
  }}
>
  {/* Overlay for fade effect */}
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)', // 
      zIndex: 1,
    }}
  ></div>

  <div className="container" style={{ position: 'relative', zIndex: 2 }}>
    <div className="row justify-content-center">
      <div className="col-lg-8">
        <nav className="custom-breadcrumbs mb-3">
          <a href="/">Home</a>
          <span className="separator">/</span>
          <a href="/conatct">contact</a>
         
          
        </nav>
        <h1 style={{color:'#c5c5c5'}} className="display-4 fw-bold">Contact Us</h1>
        <p className="lead mt-3">
          Reach out to us for web development services, inquiries, or support.
        </p>
      </div>
    </div>
  </div>
</section>
    
    {/* Contact Section */}
    {/* Contact Section */}
<section id="contact" className="contact section mt-5 light-background">
  {/* Section Title */}
  <div className="container section-title" data-aos="fade-up">
    <h2>Contact BojoTech</h2>
    <p>We relentlessly pursue opportunities for others because when we all work together, anything is possible.</p>
  </div>
  
  <div className="container" data-aos="fade-up" data-aos-delay={100}>
    <div className="row g-4 g-lg-5">

      {/* Contact Info */}
      <div className="col-lg-5">
        <div className="info-box" data-aos="fade-up" data-aos-delay={200}>
          <h3>Contact Info</h3>
          <p>We empower job seekers and businesses with customized staffing solutions for success.</p>

          
            <div className="info-item" data-aos="fade-up" data-aos-delay={300}>
            <div className="icon-box">
              <i className="bi bi-geo-alt" />
            </div>
            <div className="content">
              <h4>India Office Address</h4>
              <p>BojoTech</p>
              <p>F-2, nirmal complex, Plot no. 9-C, Govind garden, near punjab national bank, Raisen road, Govindpura, Bhopal- 462023</p>
            </div>
          </div>

          {/* <div className="info-item" data-aos="fade-up" data-aos-delay={300}>
            <div className="icon-box">
              <i className="bi bi-geo-alt" />
            </div>
            <div className="content">
              <h4>USA Office Address</h4>
              <p>CodeYuki LLC</p>
              <p>2486 Masons Ferry Dr # 103, Herndon, Virginia</p>
              <p>20171, USA</p>
            </div>
          </div> */}

          <div className="info-item" data-aos="fade-up" data-aos-delay={400}>
            <div className="icon-box">
              <i className="bi bi-envelope" />
            </div>
            <div className="content">
              <h4>Email</h4>
              <p>info@bojotech.com</p>
            </div>
            
            
          </div>
           <div className="info-item" data-aos="fade-up" data-aos-delay={400}>
            <div className="icon-box">
              <i className="bi bi-phone" />
            </div>
           
            <div className="content">
              <h4>Contact</h4>
              <p>+91 9009696937</p>
              {/* <p>+1 (267) 841-8017</p> */}
            </div>
          </div>
        </div>
      </div>

      {/* Contact Form */}
       <div className="col-lg-7">
      <div className="contact-form" data-aos="fade-up" data-aos-delay={300}>
        <h3>Get In Touch</h3>
        <p>We are ready to assist you. Send us a message and our team will get back to you promptly.</p>
        <form onSubmit={handleSubmit} className="php-email-form" data-aos="fade-up" data-aos-delay={200}>
          <div className="row gy-4">
            <div className="col-md-6">
              <input type="text" name="name" className="form-control" placeholder="Your Name" required />
            </div>
            <div className="col-md-6">
              <input type="email" name="email" className="form-control" placeholder="Your Email" required />
            </div>
            <div className="col-12">
              <input type="text" name="subject" className="form-control" placeholder="Subject" required />
            </div>
            <div className="col-12">
              <textarea name="message" className="form-control" rows={6} placeholder="Message" required />
            </div>
            <div className="col-12 text-center">
              {loading && <div className="loading">Sending...</div>}

              {statusMsg && (
                <div
                  style={{
                    padding: "10px 15px",
                    marginBottom: "10px",
                    borderRadius: "25px",
                    color: "#fff",
                    backgroundColor: isSuccess ? "green" : "red",
                  }}
                >
                  {statusMsg}
                </div>
              )}

              <button type="submit" className="btn btn-primary" disabled={loading}>
                Send Message
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    </div>
  </div>
</section>
    {/* /Contact Section */}
 
</div>

  )
}

export default Contact;

